<template>
  <v-container>
    Dataprotection
  </v-container>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import Vue from 'vue'

@Component
export default class Dataprotection extends Vue {
}
</script>

<style scoped>

</style>
